import React from 'react';
import { Form, Button } from 'react-bootstrap';

const ConditionEditor = ({ value, onChange, allFields }) => {
  const updateTopLogic = (newLogic) => {
    onChange({ ...value, logic: newLogic });
  };

  const updateGroupLogic = (groupIndex, newLogic) => {
    const updated = { ...value };
    updated.groups[groupIndex].logic = newLogic;
    onChange(updated);
  };

  const addGroup = () => {
    onChange({
      ...value,
      groups: [
        ...value.groups,
        {
          logic: 'AND',
          conditions: [{ dependsOnFieldId: '', operator: '==', expectedValue: '' }],
        },
      ],
    });
  };

  const removeGroup = (groupIndex) => {
    const updated = { ...value };
    updated.groups.splice(groupIndex, 1);
    onChange(updated);
  };

  const updateCondition = (groupIndex, condIndex, key, val) => {
    const updated = { ...value };
    updated.groups[groupIndex].conditions[condIndex][key] = val;
    onChange(updated);
  };

  const addCondition = (groupIndex) => {
    const updated = { ...value };
    updated.groups[groupIndex].conditions.push({ dependsOnFieldId: '', operator: '==', expectedValue: '' });
    onChange(updated);
  };

  const removeCondition = (groupIndex, condIndex) => {
    const updated = { ...value };
    updated.groups[groupIndex].conditions.splice(condIndex, 1);
    onChange(updated);
  };

  return (
    <>
      <Form.Label className="mt-3">Conditions (Show only if...)</Form.Label>
      <Form.Group className="mb-3">
        <Form.Label>Top-Level Logic</Form.Label>
        <Form.Select
          value={value.logic}
          onChange={(e) => updateTopLogic(e.target.value)}
        >
          <option value="AND">AND</option>
          <option value="OR">OR</option>
        </Form.Select>
      </Form.Group>

      {(value.groups || []).map((group, groupIndex) => (
        <div key={groupIndex} className="border rounded p-3 mb-3 bg-light">
          <div className="d-flex justify-content-between align-items-end mb-3">
            <div style={{ flexGrow: 1 }}>
              <Form.Label>Group #{groupIndex + 1} Logic</Form.Label>
              <Form.Select
                value={group.logic}
                onChange={(e) => updateGroupLogic(groupIndex, e.target.value)}
              >
                <option value="AND">AND</option>
                <option value="OR">OR</option>
              </Form.Select>
            </div>
            <Button variant="outline-danger" onClick={() => removeGroup(groupIndex)}>
              Remove Group
            </Button>
          </div>

          {(group?.conditions || []).map((cond, condIndex) => {
            const depField = allFields.find(f => f.id.toString() === cond.dependsOnFieldId?.toString());

            return (
              <div key={condIndex} className="border p-2 rounded mb-3">
                <Form.Group className="mb-2">
                  <Form.Label>Field</Form.Label>
                  <Form.Select
                    value={cond.dependsOnFieldId}
                    onChange={(e) => updateCondition(groupIndex, condIndex, 'dependsOnFieldId', e.target.value)}
                  >
                    <option value="">— Select Field —</option>
                    {(allFields || []).map(f => (
                      <option key={f.id} value={f.id}>{f.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Operator</Form.Label>
                  <Form.Select
                    value={cond.operator || '=='}
                    onChange={(e) => updateCondition(groupIndex, condIndex, 'operator', e.target.value)}
                  >
                    <option value="==">Equals</option>
                    <option value="!=">Not Equal</option>
                    <option value=">">Greater Than</option>
                    <option value="<">Less Than</option>
                    <option value=">=">≥ Greater or Equal</option>
                    <option value="<=">≤ Less or Equal</option>
                    <option value="contains">Contains</option>
                    <option value="not_contains">Does Not Contain</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label>Expected Value</Form.Label>
                  {['dropdown', 'radio'].includes(depField?.type) ? (
                    <Form.Select
                      value={cond.expectedValue || ''}
                      onChange={(e) => updateCondition(groupIndex, condIndex, 'expectedValue', e.target.value)}
                    >
                      <option value="">-- Select Value --</option>
                      {(depField?.options || []).map((opt, i) => (
                        <option key={i} value={opt}>{opt}</option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Value (leave blank = not empty)"
                      value={cond.expectedValue || ''}
                      onChange={(e) => updateCondition(groupIndex, condIndex, 'expectedValue', e.target.value)}
                    />
                  )}
                </Form.Group>

                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeCondition(groupIndex, condIndex)}
                >
                  × Remove Condition
                </Button>
              </div>
            );
          })}

          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => addCondition(groupIndex)}
          >
            + Add Condition
          </Button>
        </div>
      ))}

      <Button variant="outline-primary" onClick={addGroup}>
        + Add Condition Group
      </Button>
    </>
  );
};

export default ConditionEditor;